import { render, staticRenderFns } from "./RateModal.vue?vue&type=template&id=f7fe4c7c&scoped=true&"
import script from "./RateModal.vue?vue&type=script&lang=js&"
export * from "./RateModal.vue?vue&type=script&lang=js&"
import style0 from "./RateModal.vue?vue&type=style&index=0&id=f7fe4c7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7fe4c7c",
  null
  
)

export default component.exports